// Share the URL and nothing else. A `text`/`title` in the payload is what
// makes WhatsApp, Signal and the like prepend a blurb above the link, which
// buries the URL and reads as spam. The link is the whole message; the
// receiving app builds its own preview from the page's OG tags.
export type ShareData = { url: string };
export type ShareOutcome = 'shared' | 'copied' | 'failed';

export async function shareOrCopyLink(data: ShareData): Promise<ShareOutcome> {
  const nav = typeof navigator !== 'undefined' ? navigator : undefined;

  if (nav && typeof nav.share === 'function' && (nav.canShare?.(data) ?? true)) {
    try {
      await nav.share(data);
      return 'shared';
    } catch (err) {
      // User dismissed the native share sheet — treat as success, no fallback.
      if (err instanceof DOMException && err.name === 'AbortError') return 'shared';
      // Other errors fall through to the clipboard path.
    }
  }

  try {
    await nav?.clipboard.writeText(data.url);
    return 'copied';
  } catch {
    return 'failed';
  }
}
